import Firestore from 'src/authentication/handlers/firestore';
import produce, { Draft } from 'immer';
import { ActionTypes } from '../models/actions';
import {
  SET_PAYMENT_TOKENS,
  SET_PAYMENT_LOADING,
  SET_PAYMENT_SUCCESS,
} from '../models/actions/names';
import { PYMT } from '../models/store';

export default produce(
  (draft: Draft<PYMT>, action: ActionTypes) => {
    switch (action.type) {
      case SET_PAYMENT_TOKENS:
        draft.tokens = action.payload;
        break;
      case SET_PAYMENT_LOADING:
        draft.isLoading = action.payload;
        break;
      case SET_PAYMENT_SUCCESS:
        draft.isPaymentSucess = action.payload;
        break;
    }
  },
  {
    isLoading: false,
    isPaymentSucess: false,
  }
);
